export default __webpack_public_path__ + "static/media/line.4bff2d5c.svg";